import {Inject, Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {map, tap} from "rxjs/operators";
import {ModulTozsamosciService} from "../modul-tozsamosci-service/modul-tozsamosci.service";
import {SessionAlertService} from "../session-alert-service/session-alert.service";
import {MtHelper} from "../../utils/mt-helper";
import {ACCESS_TOKEN_TIME_SHIFT, REFRESH_TOKEN_TIME_SHIFT} from "../../utils/tokens";

@Injectable({
  providedIn: 'root'
})
export class PrsAuthFacadeService {

  constructor(
    private mtService: ModulTozsamosciService,
    private sessionAlertService: SessionAlertService,
    @Inject(ACCESS_TOKEN_TIME_SHIFT) private ACCESS_TOKEN_TIME_SHIFT: number,
    @Inject(REFRESH_TOKEN_TIME_SHIFT) private REFRESH_TOKEN_TIME_SHIFT: number
  ) { }

  isAuthenticated(): boolean {
    return this.mtService.isAuthenticated();
  }

  logOut(): void {
    this.mtService.logOut();
  }

  getAccessTokenObs(): Observable<string> {
    return this.accessTokenHasValidExpirationTime ? this.getAccessToken() : this.getNewAccessToken();
  }

  getAccessToken(): Observable<string> {
    return of(this.mtService.getAccessToken())
  }

  getNewAccessToken(): Observable<string> {
    return this.mtService.getNewAccessToken()
      .pipe(
        tap(() => this.updateAlertTimer()),
        map(response => response?.access_token)
      );
  }

  updateAlertTimer(): void {
    const timerValue = MtHelper.getAlertTime(this.mtService.getRefreshTokenExpiration(), this.REFRESH_TOKEN_TIME_SHIFT);
    this.sessionAlertService.updateAlertTimer(timerValue);
  }

  get accessTokenHasValidExpirationTime(): boolean {
    return MtHelper.isValidToken(this.mtService.getAccessTokenExpiration(), this.ACCESS_TOKEN_TIME_SHIFT);
  }

}
